import Page from "@subly/s1/ui/base/Page";


export default function Home() {
	return (
		<Page>
			<Page.Header title="Home" />
			<Page.Body>
				Imagine a beautiful home page here
			</Page.Body>
		</Page>
	);
}